import React, { useEffect } from 'react';
import '../styles/ProductoCard.css';
import descripcionProductos from '../../../utils/descripcionProductos';
import iconTratamiento from '../../../icons/tratamiento.png';
import iconLista from '../../../icons/lista.png';

const normalize = str =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '');

const ProductoCard = ({ productoNombre, onClose }) => {
  const normalizado = normalize(productoNombre);

  const productoId = Object.keys(descripcionProductos).find(key => {
    return normalize(descripcionProductos[key].nombre) === normalizado;
  });

  const data = descripcionProductos[productoId];

  // ✅ Bloquear scroll del body y aplicar clase modal
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('modal-open');

    return () => {
      document.body.style.overflow = originalStyle;
      document.body.classList.remove('modal-open');
    };
  }, []);

  if (!data) return <div>Producto no encontrado.</div>;

  const handleClose = e => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  // Cerrar al hacer click en el backdrop
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      handleClose(e);
    }
  };

  return (
    <div className="producto-card-backdrop" onClick={handleBackdropClick}>
      <div className="producto-card">
        <button
          className="close-button-productos"
          onClick={handleClose}
          type="button"
          aria-label="Cerrar"
        >
          ✕
        </button>

        <div className="producto-content">
          <div className="producto-info">
            <h1 className="titulo-productos">{data.nombre}</h1>
            <p className="dosis">
              {data.principioActivo} <strong>{data.dosis}</strong>
            </p>
            {/* <p className="descripcion"><em>{data.slogan}</em></p> */}
            <p className="descripcion">
              {(() => {
                const index = data.slogan.indexOf('.');
                if (index !== -1) {
                  return (
                    <>
                      <strong>{data.slogan.slice(0, index + 1)}</strong>
                      <span>{data.slogan.slice(index + 1)}</span>
                    </>
                  );
                } else {
                  return <strong>{data.slogan}</strong>;
                }
              })()}
            </p>
            <div className="icon-section">
              <img
                src={iconTratamiento}
                alt="icono tratamiento"
                className="icono"
              />
              <div>
                <strong>Indicaciones</strong>
                <ul className="tratamientos">
                  {data.Indicaciones.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="icon-section">
              <img src={iconLista} alt="icono lista" className="icono" />
              <p>
                <strong>Posología:</strong> {data.posología}
                <br />
                {data.regulación && (
                  <>
                    <strong>{data.regulación.titulo}</strong>
                    {data.regulación.contenido}
                  </>
                )}
              </p>
            </div>
          </div>

          <div className="producto-img">
            <img src={data.imagen} alt={data.nombre} />
            <p className="caja-info">{data.cajaInfo}</p>
          </div>
        </div>

        <div className="advertencias">
          <p>
            <strong>ADVERTENCIAS:</strong> {data.advertencias}
          </p>
          <p>
            <strong>CONTRAINDICACIONES:</strong> {data.contraindicaciones}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductoCard;
